var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewsStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA16",
    fillRule: "evenodd",
    d: "m8 11.6-4.702 2.872 1.278-5.36L.392 5.528l5.492-.44L8 0l2.116 5.088 5.492.44-4.184 3.584 1.278 5.36L8 11.6ZM26 11.6l-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44L26 0l2.116 5.088 5.492.44-4.184 3.584 1.278 5.36L26 11.6ZM62 11.6l-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44L62 0l2.116 5.088 5.493.44-4.185 3.584 1.278 5.36L62 11.6ZM44 11.6l-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44L44 0l2.116 5.088 5.492.44-4.184 3.584 1.278 5.36L44 11.6ZM80 11.6l-4.702 2.872 1.278-5.36-4.184-3.584 5.492-.44L80 0l2.116 5.088 5.493.44-4.185 3.584 1.278 5.36L80 11.6Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewsStars);
export default __webpack_public_path__ + "static/media/reviews-stars.c4f9b96346261ec8d27397bd4714d345.svg";
export { ForwardRef as ReactComponent };